/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { ButtonProps } from '@chakra-ui/react';
import type { BorderRadius, ButtonSize, ButtonVariantType, FullButtonKey } from './default/Buttons';

const variantGenerator = (variants: readonly ButtonVariantType[]) => {
  const sizes: readonly ButtonSize[] = ['ExtraLarge', 'Large', 'Medium', 'Small'];
  const borderRadiusOptions: readonly BorderRadius[] = ['Rounded', 'NonRounded'];

  return variants.reduce(
    (acc, variant) => {
      sizes.forEach((size) => {
        borderRadiusOptions.forEach((borderRadius) => {
          const key: FullButtonKey = `${variant}/${size}/${borderRadius}`;
          acc[key] = key;
        });
      });
      return acc;
    },
    {} as Record<FullButtonKey, FullButtonKey>,
  );
};

const generatedMainButtonVariants = variantGenerator([
  'Primary',
  'Secondary',
  'Tertiary',
  'Danger',
  'Success',
] as readonly ButtonVariantType[]);

const mainButtonVariantKeys = Object.keys(generatedMainButtonVariants) as Array<
  keyof typeof generatedMainButtonVariants
>;

const _ButtonVariants = [
  'submit',
  'secondary',
  'secondary_outlined',
  ...mainButtonVariantKeys,
  'Button/Type1',
  'Button/Type2',
  'Button/Type3',
] as const;

export type ButtonType = (typeof _ButtonVariants)[number];

export type KaryaButtonTheme = { [key in ButtonType]: ButtonProps };

export const ButtonVariant = {
  submit: 'submit',
  secondary: 'secondary',
  secondary_outlined: 'secondary_outlined',
  ...generatedMainButtonVariants,
  'Button/Type1': 'Button/Type1',
  'Button/Type2': 'Button/Type2',
  'Button/Type3': 'Button/Type3',
} as const;
